import { GraduationCap } from "@phosphor-icons/react";
import PlanejamentoDocModule from "./PlanejamentoDocModule";

export default function TR() {
  return (
    <PlanejamentoDocModule
      endpoint="trs"
      title="TR / PB — Termo de Referência / Projeto Básico"
      subtitle="Etapa 4 · Planejamento"
      baseLegal="Lei 14.133/2021 · art. 6º, XXIII e art. 40, §1º"
      Icon={GraduationCap}
      acentoColor="#009C3B"
      promoverLabel="Gerar Matriz de Riscos"
      promoverPath="/trs/{id}/promover-matriz"
      nextRoute="/matrizes-riscos"
    />
  );
}
